import { EmployeeAppraisal } from "../../components/features/EmployeeAppraisal/index.ts";
import PageShell from "../../components/shared/page-shell/page-shell.tsx";
import { useLocation } from "react-router-dom";
import type { AppraisalFormRouteState } from "../../components/features/EmployeeAppraisal/appraisal-prefill.ts";

export default function EmployeeAppraisalPage() {
  const location = useLocation();
  const routeState = location.state as AppraisalFormRouteState | null;
  const initialAppraisal = routeState?.draftAppraisal ?? routeState?.rejectedAppraisal;

  return (
    <PageShell>
      <EmployeeAppraisal initialAppraisal={initialAppraisal} />
    </PageShell>
  );
}
